// Všechny časové údaje v aplikaci se zobrazují napevno v této zóně,
// bez ohledu na to, v jaké zóně je prohlížeč uživatele.
export const DISPLAY_TIME_ZONE = "Europe/Prague"

export const DISPLAY_LOCALE = "cs-CZ"

// Vrací true, pokud se aktuální čas prohlížeče liší od času v DISPLAY_TIME_ZONE
// (tzn. zobrazované časy nejsou lokálním časem uživatele). Porovnáváme reálný
// "wall-clock" čas, takže uživatel v zóně se stejným posunem (Bratislava, Berlín…)
// zbytečně varování nedostane.
export const browserDiffersFromDisplayZone = (): boolean => {
   try {
      const now = new Date()
      const local = now.toLocaleString("en-GB", { hour12: false })
      const display = now.toLocaleString("en-GB", {
         hour12: false,
         timeZone: DISPLAY_TIME_ZONE,
      })
      return local !== display
   } catch {
      return false
   }
}
